export default __webpack_public_path__ + "static/125-min-min-738dd5b638682414cf144bbdfc2bc106.jpg";